var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeam4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 175,
    viewBox: "0 0 176 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 87.5,
    r: 87,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_411",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 176,
    height: 175
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 87.5,
    r: 87.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.676 101.562C64.825 105.541 67.908 108.95 70.108 112.901C73.532 119.044 74.667 126.24 74.604 133.273C74.587 135.196 74.503 137.209 75.339 138.942C77.132 142.658 82.044 143.328 86.167 143.507C92.735 143.792 101.221 142.748 102.846 136.378C103.511 133.769 102.686 131.042 102.515 128.356C101.991 120.082 107.658 112.737 113.717 107.08C119.777 101.422 126.753 96.2723 130.297 88.7773C131.215 86.8353 131.863 84.4964 130.864 82.5954C128.702 78.4784 121.309 80.1504 119.024 76.0994C118.339 74.8844 118.313 73.4263 118.154 72.0403C116.729 59.6563 103.233 51.4474 90.774 51.8444C81.253 52.1484 63.779 57.1473 59.496 66.8083C55.554 75.6993 58.326 93.5033 62.676 101.562Z",
    fill: "#FFE7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8514 196.225C28.7284 200.123 29.4004 204.653 32.7454 206.658C34.4264 207.666 36.4694 207.813 38.4264 207.928C73.9564 210.011 109.614 209.903 145.13 207.608C146.105 207.544 147.143 207.456 147.915 206.859C149.517 205.616 149.033 203.117 148.371 201.202C144.944 191.299 140.867 181.621 136.173 172.252C133.414 166.739 129.934 160.888 124.105 158.882C115.995 156.09 107.704 161.909 99.3294 163.762C82.6654 167.448 68.5314 149.583 53.3914 154.398C38.1244 159.252 29.3054 181.828 28.8514 196.225Z",
    fill: "#C3C62B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0424 146.823C67.7314 147.323 67.4294 147.873 67.4624 148.46C67.5034 149.17 68.0174 149.752 68.5204 150.255C78.9154 160.656 96.8585 162.36 109.024 154.1C110.547 153.066 112.03 151.838 112.807 150.169C114.338 146.881 112.533 142.751 109.513 140.742C106.494 138.733 102.628 138.458 99.0245 138.858C95.4195 139.257 91.8984 140.26 88.2844 140.57C79.2534 141.347 73.3854 138.231 68.0424 146.823Z",
    fill: "#6987FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2707 95.6216C69.8387 95.6456 67.4087 95.6696 64.9777 95.6936C64.2787 95.6996 63.4867 95.7486 63.0387 96.2856C62.4877 96.9456 62.8137 98.0206 63.4887 98.5536C64.1627 99.0866 65.0587 99.2226 65.9117 99.3396C67.0067 99.4906 68.1027 99.6416 69.1987 99.7926C70.7427 100.006 72.4947 100.162 73.6847 99.1556C74.8757 98.1506 74.4287 95.6006 72.8747 95.7186",
    fill: "#F03FA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.452 96.8413C104.021 96.8653 101.59 96.8893 99.1591 96.9123C98.4611 96.9193 97.6681 96.9693 97.2201 97.5053C96.6691 98.1653 96.9961 99.2393 97.6691 99.7733C98.3441 100.307 99.2411 100.443 100.092 100.56C101.188 100.71 102.284 100.861 103.379 101.012C104.924 101.225 106.676 101.382 107.867 100.375C109.057 99.3693 108.61 96.8193 107.055 96.9383",
    fill: "#F03FA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3965 76.9634C66.2095 76.2814 67.1615 75.8744 68.1295 75.5764C69.1045 75.2894 70.1205 75.1524 71.1375 75.1494C73.1595 75.1474 75.2725 75.6774 76.8615 77.0584C75.8005 77.1604 74.8645 77.1104 73.9185 77.1424L71.1415 77.1494C69.2895 77.1314 67.4635 77.1774 65.3965 76.9634Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9669 86.8854C72.9669 88.5004 72.1458 89.8094 71.1328 89.8094C70.1198 89.8094 69.2979 88.5004 69.2979 86.8854C69.2979 85.2714 70.1198 83.9624 71.1328 83.9624C72.1458 83.9624 72.9669 85.2714 72.9669 86.8854Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.42 76.8221C103.356 77.0621 101.531 77.0371 99.678 77.0761L96.903 77.1041C95.956 77.0821 95.019 77.1451 93.959 77.0551C95.53 75.6551 97.637 75.0991 99.658 75.0771C100.676 75.0681 101.692 75.1931 102.67 75.4681C103.643 75.7541 104.6 76.1501 105.42 76.8221Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2979 86.8854C98.2979 88.5004 99.1198 89.8094 100.133 89.8094C101.146 89.8094 101.967 88.5004 101.967 86.8854C101.967 85.2714 101.146 83.9624 100.133 83.9624C99.1198 83.9624 98.2979 85.2714 98.2979 86.8854Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0473 85.2295C82.1633 85.4815 81.7333 92.1835 80.5693 95.4475C80.5693 95.4475 80.5693 100.117 85.9433 99.1365",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7656 106.104C78.7656 106.104 86.7636 106.643 93.1216 105.549",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 204.009L32.03 180.879C34.68 168.689 42.13 158.089 52.7 151.458L72.25 139.198L72.83 133.019H72.84L74.15 119.099L74.18 118.799",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.89 204.009L139.86 180.879C137.21 168.689 129.76 158.089 119.19 151.458L99.6403 139.198L98.2502 124.589L97.7603 119.328L97.7402 119.158",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2305 67.6792C53.6705 68.4292 52.6705 97.9582 70.3105 115.679C74.3305 119.708 79.3204 123.139 85.5204 125.458C85.5204 125.458 91.1805 124.599 97.7605 119.328C99.0605 118.299 100.39 117.089 101.72 115.679C109.28 107.698 116.82 93.3492 117.67 67.6792",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5942 83.8503C54.5942 83.8503 47.1882 76.0093 44.0782 80.2033C40.9662 84.3993 49.3522 102.715 59.7902 99.5943",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0996 87.3942C49.0996 87.3942 54.1286 86.9912 56.6126 90.7952",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1084 91.1721C52.1084 91.1721 52.1224 89.4411 55.3594 89.3701",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.038 83.8503C116.038 83.8503 122.914 75.5394 126.294 79.5224C129.672 83.5044 122.506 102.331 111.886 99.9014",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.94 87.0294C121.94 87.0294 116.896 86.9574 114.667 90.9164",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.184 90.9961C119.184 90.9961 119.057 89.2701 115.823 89.4121",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2471 139.195C72.2471 139.195 85.7011 148.804 99.6391 139.195",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4504 143.466L78.8764 151.753C78.8764 151.753 71.4304 149.929 67.8154 141.975",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7363 143.466L93.3093 151.753C93.3093 151.753 100.755 149.929 104.37 141.975",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0791 144.945C63.0791 144.945 72.5261 157.868 85.9431 160.467C85.9431 160.467 100.062 158.579 108.043 144.466",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.165 146.864C60.165 146.864 72.526 161.766 85.943 164.364C85.943 164.364 102.931 160.378 110.912 146.265",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9434 164.364V204.011",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.371 57.7405C104.371 57.7405 82.1008 70.0945 67.8158 71.0405C53.5318 71.9865 55.2588 84.9965 55.2588 84.9965C55.2588 84.9965 44.0998 70.5815 45.4748 50.1745C46.8508 29.7675 88.0968 14.1745 108.633 30.9135C108.633 30.9135 136.982 43.6725 116.329 82.2765C116.329 82.2765 108.693 75.6265 104.371 57.7405Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9627 29.7264C97.1007 28.1034 97.4227 26.4964 97.9287 24.9494C99.4957 20.1584 104.502 17.6354 109.306 17.1134C110.929 16.9374 112.587 16.9404 114.176 17.3084C118.559 18.3224 121.938 22.0504 123.586 26.2364C124.71 29.0914 125.15 32.2144 124.845 35.2684C124.673 36.9904 124.258 38.7124 123.397 40.2144C122.71 41.4134 121.753 42.4454 120.677 43.3144C116.835 46.4204 110.869 47.5084 106.1 46.5184C102.923 45.8604 100.576 43.8864 99.1177 41.0274C97.3507 37.5624 96.6327 33.5974 96.9627 29.7264Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2508 124.589C92.3008 126.658 80.4108 130.559 72.8408 133.019L74.1508 119.099C77.4008 121.649 81.1608 123.828 85.5208 125.458C85.5208 125.458 91.1808 124.599 97.7608 119.328L98.2508 124.589Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam4);
export default __webpack_public_path__ + "static/media/team4.12016965da9e4c9141cd60452e30c9f8.svg";
export { ForwardRef as ReactComponent };